export default function maskInput(element, mask) {
  const $el = window.$ ? window.$(element) : null;
  if (!$el || typeof $el.inputmask !== 'function') return;

  const common = { rightAlign: false, removeMaskOnSubmit: true };

  switch (mask) {
    case 'cpf':
      $el.inputmask('999.999.999-99', common);
      break;
    case 'cnpj':
      $el.inputmask('99.999.999/9999-99', common);
      break;
    case 'phone':
      $el.inputmask('(99) 99999-9999', common);
      break;
    case 'zipcode':
      $el.inputmask('99999-999', common);
      break;
    case 'date':
      $el.inputmask('d/m/y', common);
      break;
    case 'email':
      $el.inputmask({ alias: 'email', ...common });
      break;
    case 'percentage': {
      const opts = { alias: 'percentage', ...common };
      $el.inputmask(opts);
      break;
    }
    case 'currency': {
      const opts = {
        alias: 'currency',
        prefix: 'R$ ',
        groupSeparator: '',
        radixPoint: '.',
        radixFocus: true,
        ...common
      };
      $el.inputmask(opts);
      break;
    }
    default:
      // Fallback to provided mask pattern if any
      if (typeof mask === 'string' && mask) {
        $el.inputmask(mask, common);
      }
  }
}


